import React, { createContext, useState, useContext, useMemo } from "react";
import { motion } from "motion/react";

import { useAuth } from "../../contexts/AuthContext";
import SignUpModal from "../ui-new/SignUpModal";

const ModalContext = createContext(null);

// Custom hook to use the modal context
export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error(
      "useModalContext must be used within a ModalContextProvider"
    );
  }
  return context;
};

export default function ModalContextProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user, isLoading } = useAuth();
  const [accessToken, setAccessToken] = useState(null);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      isModalOpen,
      setIsModalOpen,
      accessToken,
      setAccessToken,
    }),
    [isModalOpen, accessToken]
  );

  return (
    <ModalContext.Provider value={contextValue}>
      {isModalOpen && !user && !isLoading && (
        <motion.div
          className="w-full h-full fixed top-0 left-0 bg-penta-black/50 z-[100] flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="px-4"
          >
            <SignUpModal />
          </motion.div>
        </motion.div>
      )}
      {children}
    </ModalContext.Provider>
  );
}
